import type { ExperienceConfig } from '@quickguidehealth/experience-config';

/**
 * Build-time fallback experience config.
 *
 * Used by {@link loadRuntimeExperienceConfig} when the runtime
 * `/experience-config.json` is unavailable (local `vite` dev, tests, or a failed
 * fetch). In a real deployment the ConfigMap-served document overrides this.
 *
 * `appIdToKey` is empty here because the logical-key mapping is generated by the
 * migration-service bootstrap from the Logto apps it creates — local dev has no
 * real `app_id`, so it resolves to `defaults` (optionally narrowed by hostname).
 */
export const defaultExperienceConfig: ExperienceConfig = {
  appIdToKey: {},
  defaults: {
    signIn: { connectors: ['google', 'apple', 'github', 'microsoft'] },
    signUp: { enabled: true, connectors: ['google', 'apple', 'github', 'microsoft'] },
  },
  domains: {
    'auth.turfle.de': {
      branding: { primaryColor: '#00a884' },
    },
    'auth.quickguide.cloud': {
      branding: { primaryColor: '#0b62d6' },
    },
  },
  apps: {
    // Example per-app overrides, keyed by logical app key (resolved from `app_id`
    // via `appIdToKey`). Real values live in the ConfigMap document.
    'turfle-web': {
      signIn: { connectors: ['google', 'apple'] },
      signUp: { enabled: true, connectors: ['google', 'apple'] },
    },
    'turfle-native': {
      signIn: { connectors: ['apple', 'google'] },
    },
    'qg-studio': {
      signIn: { connectors: ['microsoft', 'google'] },
      signUp: { enabled: false, connectors: [] },
    },
    'qg-app': {
      signIn: { connectors: ['google', 'apple'] },
    },
  },
};
